import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { UiNotificationService } from '../../services/ui-notification.service';
import { Alert } from '../../models/summary';
import { ApiService } from '../../services/api.service';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { TrendIndicatorComponent } from '../../components/trend-indicator/trend-indicator.component';
import { ThresholdIndicatorComponent } from '../../components/threshold-indicator/threshold-indicator.component';
import { Parameters } from '../../utilities/parameters';
import { HttpErrorResponse } from '@angular/common/http';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-alert-dialog',
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TranslatePipe,
    DividerModule,
    DatePipe,
    ButtonModule,
    TrendIndicatorComponent,
    ThresholdIndicatorComponent
  ],
  templateUrl: './alert-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class AlertDialogComponent implements OnChanges {
  private translate = inject(TranslateService);

  @Input() messageService!: UiNotificationService;
  @Input() alert: Alert = Reset.alert();

  // visibilità dialog (bidirezionale)
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  // evento finale
  @Output() closed = new EventEmitter<Alert>();

  isTrend: boolean = false
  mode: any = "FC";
  uom: string = "bpm";
  
  private percent : number[] = [3, 4, 7, 8, 11, 12, 15, 16];
  private heart: number[] = [1, 2, 5, 6]
  private breath: number[] = [9, 10, 13, 14]

  constructor(private apiService: ApiService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['alert'] && this.alert) {
      this.isTrend = this.percent.includes(this.alert.type);
      this.mode = this.alert.type < 9 ? 'FC' : 'FR';

      if (this.heart.includes(this.alert.type)) {
        this.uom = "bpm";
      } else if (this.breath.includes(this.alert.type)) {
        this.uom = "rpm";
      } else {
        this.uom = "";
      }
    }
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onSave() {
    if (!this.alert.isChecked) {
      this.alert.isChecked = true;
      this.alert.checkedBy = Parameters.loggedUser.id;
      this.alert.checker = `${Parameters.loggedUser.familyName} ${Parameters.loggedUser.name}`;

      this.apiService.setPatientAlertVerified(this.alert).subscribe({
        next: (r) => {
          if (r) {
            this.closed.emit(this.alert);
            this.onClose();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.showError(err);
        }
      })
    }
  }
}
